import React from 'react';
import DateRangePicker from '../DateRangePicker';
import * as echarts from 'echarts/lib/echarts';
import echartsColorTheme from '../echartsColorTheme';

import 'echarts/lib/chart/line';
import 'echarts/lib/chart/bar';
// import 'echarts/lib/chart/pie';
// import 'echarts/lib/chart/scatter';
// import 'echarts/lib/chart/radar';

// import 'echarts/lib/chart/map';
// import 'echarts/lib/chart/treemap';
// import 'echarts/lib/chart/graph';
// import 'echarts/lib/chart/gauge';
// import 'echarts/lib/chart/funnel';
// import 'echarts/lib/chart/parallel';
// import 'echarts/lib/chart/sankey';
// import 'echarts/lib/chart/boxplot';
// import 'echarts/lib/chart/candlestick';
// import 'echarts/lib/chart/effectScatter';
// import 'echarts/lib/chart/lines';
// import 'echarts/lib/chart/heatmap';

// import 'echarts/lib/component/graphic';
import 'echarts/lib/component/grid';
import 'echarts/lib/component/legend';
import 'echarts/lib/component/tooltip';
// import 'echarts/lib/component/polar';
// import 'echarts/lib/component/geo';
// import 'echarts/lib/component/parallel';
// import 'echarts/lib/component/singleAxis';
// import 'echarts/lib/component/brush';

// import 'echarts/lib/component/title';

import 'echarts/lib/component/dataZoom';
// import 'echarts/lib/component/visualMap';

// import 'echarts/lib/component/markPoint';
// import 'echarts/lib/component/markLine';
// import 'echarts/lib/component/markArea';

// import 'echarts/lib/component/timeline';
import 'echarts/lib/component/toolbox';
import 'echarts/lib/component/transform';

const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

const anthrax_monthly_data = [["month", "origin", "model"], ["2005-1", 3, null], ["2005-2", 1, null], ["2005-3", 4, null], ["2005-4", 2, null], ["2005-5", 3, null], ["2005-6", 4, null], ["2005-7", 12, null], ["2005-8", 5, null], ["2005-9", 4, null], ["2005-10", 4, null], ["2005-11", 5, null], ["2005-12", 3, null], ["2006-1", 3, 3.30], ["2006-2", 2, 2.16], ["2006-3", 2, 1.80], ["2006-4", 3, 2.78], ["2006-5", 2, 1.76], ["2006-6", 4, 3.83], ["2006-7", 7, 12.27], ["2006-8", 13, 4.47], ["2006-9", 5, 4.83], ["2006-10", 5, 4.93], ["2006-11", 6, 5.97], ["2006-12", 2, 4.05], ["2007-1", 1, 3.93], ["2007-2", 0, 2.43], ["2007-3", 0, 1.79], ["2007-4", 3, 2.48], ["2007-5", 5, 1.51], ["2007-6", 4, 4.05], ["2007-7", 10, 11.44], ["2007-8", 9, 6.80], ["2007-9", 5, 4.64], ["2007-10", 8, 4.75], ["2007-11", 5, 6.26], ["2007-12", 6, 3.76], ["2008-1", 3, 4.12], ["2008-2", 0, 2.98], ["2008-3", 2, 2.38], ["2008-4", 2, 3.71], ["2008-5", 8, 2.96], ["2008-6", 9, 5.08], ["2008-7", 5, 12.80], ["2008-8", 6, 7.89], ["2008-9", 12, 4.77], ["2008-10", 3, 6.45], ["2008-11", 2, 6.12], ["2008-12", 4, 3.84], ["2009-1", 7, 3.26], ["2009-2", 1, 2.50], ["2009-3", 5, 2.61], ["2009-4", 4, 4.11], ["2009-5", 4, 4.86], ["2009-6", 4, 5.88], ["2009-7", 7, 10.54], ["2009-8", 14, 7.37], ["2009-9", 5, 7.24], ["2009-10", 2, 5.50], ["2009-11", 4, 5.03], ["2009-12", 4, 4.02], ["2010-1", 1, 4.08], ["2010-2", 1, 1.32], ["2010-3", 2, 2.33], ["2010-4", 1, 2.95], ["2010-5", 1, 3.29], ["2010-6", 3, 3.91], ["2010-7", 10, 8.40], ["2010-8", 6, 7.91], ["2010-9", 1, 4.83], ["2010-10", 2, 2.62], ["2010-11", 1, 3.05], ["2010-12", 3, 2.07], ["2011-1", 1, 1.70], ["2011-2", 3, -0.19], ["2011-3", 2, 1.35], ["2011-4", 4, 1.82], ["2011-5", 5, 2.71], ["2011-6", 2, 4.27], ["2011-7", 6, 9.03], ["2011-8", 17, 7.19], ["2011-9", 9, 5.51], ["2011-10", 4, 5.00], ["2011-11", 9, 5.10], ["2011-12", 6, 5.57], ["2012-1", 8, 4.82], ["2012-2", 5, 4.25], ["2012-3", 2, 4.94], ["2012-4", 8, 5.16], ["2012-5", 5, 6.17], ["2012-6", 7, 6.36], ["2012-7", 3, 11.41], ["2012-8", 4, 11.16], ["2012-9", 4, 5.76], ["2012-10", 7, 3.62], ["2012-11", 8, 5.29], ["2012-12", 3, 4.94], ["2013-1", 7, 4.35], ["2013-2", 3, 3.24], ["2013-3", 3, 3.09], ["2013-4", 5, 4.82], ["2013-5", 6, 4.68], ["2013-6", 6, 5.58], ["2013-7", 14, 8.91], ["2013-8", 10, 10.92], ["2013-9", 7, 7.46], ["2013-10", 15, 6.48], ["2013-11", 10, 8.80], ["2013-12", 4, 7.35], ["2014-1", 6, 7.41], ["2014-2", 4, 5.15], ["2014-3", 3, 4.89], ["2014-4", 5, 6.40], ["2014-5", 5, 6.24], ["2014-6", 2, 6.59], ["2014-7", 11, 10.04], ["2014-8", 21, 10.30], ["2014-9", 10, 8.67], ["2014-10", 6, 9.64], ["2014-11", 11, 8.77], ["2014-12", 8, 6.62], ["2015-1", 6, 7.75], ["2015-2", 5, 5.49], ["2015-3", 1, 5.19], ["2015-4", 7, 6.45], ["2015-5", 5, 6.61], ["2015-6", 5, 6.27], ["2015-7", 15, 11.26], ["2015-8", 20, 13.77], ["2015-9", 10, 9.71], ["2015-10", 8, 9.59], ["2015-11", 5, 10.13], ["2015-12", 9, 6.71], ["2016-1", 1, 7.40], ["2016-2", 4, 4.67], ["2016-3", 7, 3.66], ["2016-4", 3, 6.93], ["2016-5", 11, 6.01], ["2016-6", 4, 6.73], ["2016-7", 8, 12.44], ["2016-8", 17, 14.18], ["2016-9", 17, 8.50], ["2016-10", 10, 9.26], ["2016-11", 8, 9.48], ["2016-12", 6, 8.01], ["2017-1", 7, 6.42], ["2017-2", 2, 5.81], ["2017-3", 2, 5.08], ["2017-4", 6, 6.03], ["2017-5", 8, 7.37], ["2017-6", 4, 5.99], ["2017-7", 22, 11.48], ["2017-8", 27, 16.83], ["2017-9", 14, 13.32], ["2017-10", 8, 11.45], ["2017-11", 7, 10.63], ["2017-12", 5, 8.73], ["2018-1", 2, 7.37], ["2018-2", 5, 5.05], ["2018-3", 4, 5.02], ["2018-4", 5, 6.84], ["2018-5", 0, 8.03], ["2018-6", 8, 4.86], ["2018-7", 5, 13.47], ["2018-8", 11, 15.90], ["2018-9", 9, 8.35], ["2018-10", 7, 5.71], ["2018-11", 3, 5.56], ["2018-12", 2, 3.81], ["2019-1", 2, 2.43], ["2019-2", 3, 1.84], ["2019-3", 3, 1.81], ["2019-4", 2, 3.82], ["2019-5", 4, 3.85], ["2019-6", 2, 4.00], ["2019-7", 5, 9.66], ["2019-8", 7, 13.34], ["2019-9", 3, 6.61], ["2019-10", 4, 3.45], ["2019-11", 1, 2.47], ["2019-12", 0, 1.02], ["2020-1", null, 0.02], ["2020-2", null, -0.21], ["2020-3", null, -0.41], ["2020-4", null, 0.86], ["2020-5", null, 1.53], ["2020-6", null, 1.26], ["2020-7", null, 6.72], ["2020-8", null, 10.78], ["2020-9", null, 5.51], ["2020-10", null, 3.67], ["2020-11", null, 2.23], ["2020-12", null, 1.09], ["2021-1", null, 0.43], ["2021-2", null, 0.21], ["2021-3", null, 0.01], ["2021-4", null, 1.27], ["2021-5", null, 1.94], ["2021-6", null, 1.67], ["2021-7", null, 7.13], ["2021-8", null, 11.19], ["2021-9", null, 5.93], ["2021-10", null, 4.09], ["2021-11", null, 2.65], ["2021-12", null, 1.50], ["2022-1", null, 0.84], ["2022-2", null, 0.62], ["2022-3", null, 0.42], ["2022-4", null, 1.68], ["2022-5", null, 2.36], ["2022-6", null, 2.08], ["2022-7", null, 7.55], ["2022-8", null, 11.60], ["2022-9", null, 6.34], ["2022-10", null, 4.50], ["2022-11", null, 3.06], ["2022-12", null, 1.91], ["2023-1", null, 1.25], ["2023-2", null, 1.03], ["2023-3", null, 0.83], ["2023-4", null, 2.09], ["2023-5", null, 2.77], ["2023-6", null, 2.49], ["2023-7", null, 7.96], ["2023-8", null, 12.02], ["2023-9", null, 6.75], ["2023-10", null, 4.91], ["2023-11", null, 3.47], ["2023-12", null, 2.33], ["2024-1", null, 1.67], ["2024-2", null, 1.44], ["2024-3", null, 1.24], ["2024-4", null, 2.51], ["2024-5", null, 3.18], ["2024-6", null, 2.91], ["2024-7", null, 8.37], ["2024-8", null, 12.43], ["2024-9", null, 7.16], ["2024-10", null, 5.32], ["2024-11", null, 3.88], ["2024-12", null, 2.74]];

class MonthlyLineChart extends React.Component {
  constructor(props) {
    super(props);
    echarts.registerTheme('customColorTheme', echartsColorTheme);
    this.myChart = null;
    this.state = {
      startYear: 2005,
      endYear: 2019,
      startMonth: 1,
      endMonth: 12,
      startYearRange: '2005-1',
      endYearRange: '2019-12'
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(event) {
    if (parseInt(this.state.startYear) > parseInt(this.state.endYear)) {
      alert(`Invalid year range from ${this.state.startYear} to ${this.state.endYear}.`);
      return;
    } else if (parseInt(this.state.startMonth) > parseInt(this.state.endMonth)) {
      alert(`Invalid month range from ${months[this.state.startMonth - 1]} to ${months[this.state.endMonth - 1]}.`);
      return;
    } else {
      var startMonth = this.state.startYear + '-' + this.state.startMonth;
      var endMonth = this.state.endYear + '-' + this.state.endMonth;
      // update chart
      this.myChart.setOption({
        dataset: [{
          source: anthrax_monthly_data
        }, {
          transform: {
            type: 'filter',
            config: {
              dimension: 'month', '>=': startMonth, '<=': endMonth, parser: 'time'
            }
          }
        }]
      });
      this.setState({
        startYearRange: startMonth,
        endYearRange: endMonth
      });
    }
  }

  handleInputChange(event) {
    const target = event.target;
    this.setState({
      [target.name]: target.value
    });
  }

  componentDidMount() {
    echarts.registerTheme('customColorTheme', echartsColorTheme, 'EN');
    this.myChart = echarts.init(document.getElementById('monthly-line-chart'), 'customColorTheme');
    var option = {
      grid: {
        left: 'center',
        width: '85%',
        top: '10%',
      },
      animation: true,
      tooltip: {
        trigger: 'axis',
        position: function (pt) {
          return [pt[0], '15%'];
        }
      },
      toolbox: {
        feature: {
          saveAsImage: {}
        }
      },
      legend: {
        data: ['origin series'],
        left: 'center',
        top: '0px',
      },
      dataZoom: [{
        type: 'slider',
        start: 0,
        end: 100
      }, {
        type: 'inside',
        start: 0,
        end: 100
      }
      ],
      xAxis: { type: 'category' },
      yAxis: { type: 'value' },
      dataset: [{
        source: anthrax_monthly_data
      }, {
        transform: {
          type: 'filter',
          config: {
            dimension: 'month', '>=': this.state.startYearRange, '<=': this.state.endYearRange, parser: 'time'
          }
        }
      }],
      series: [{
        type: 'line',
        symbol: 'none',
        name: 'origin series',
        datasetIndex: 1,
        encode: {
          x: 'month',
          y: 'origin',
        },
      }]
    };
    this.myChart.setOption(option);
  }
  render() {
    return (
      <>
        <DateRangePicker
          startYear={this.state.startYear}
          endYear={this.state.endYear}
          startMonth={this.state.startMonth}
          endMonth={this.state.endMonth}
          onChange={this.handleInputChange}
          onClick={this.handleSubmit}
        />
        <div class="m-auto" id="monthly-line-chart" style={{ height: '360px' }}></div>
      </>
    );
  }
}

export default MonthlyLineChart;